module.exports = __webpack_public_path__ + "img/reset-password-active.4cf4fca7.svg";